import { Vendor } from './vendor.model';
import { SubcontractorCategory } from './subcontractor-category.model';
import { SubcontractorVendor } from './subcontractor-vendor.model';

export class Subcontractors {
  subcontractorCategories: SubcontractorCategory[];
  subcontractorVendors: SubcontractorVendor[];
  vendors: Vendor[];
}
